import { catchError, of, OperatorFunction } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export function handleHttp500<T>(emptyValue: T): OperatorFunction<T, T> {
  return catchError((error: any) => {
    if (error instanceof HttpErrorResponse && error.status === 500) {
      return of(emptyValue);
    }

    throw error;
  });
}
